import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { SettingsPage } from "@/features/settings";

export const Route = createFileRoute("/settings/")({
  component: () => (
    <PermissionGuard module="settings">
      <SettingsPage />
    </PermissionGuard>
  ),
});
